import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const check = () => {
      const first = document.getElementById('first-cta');
      if (!first) return;
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-127" data-mp="38bh1o3b2u01q">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2" initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-128" data-mp="38cjtqek4y8j8">
          <motion.a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-cta px-5 py-4 text-[16px] font-extrabold uppercase tracking-wide text-cta-ink shadow-[0_5px_0_0_#C99700,0_12px_30px_rgba(38,12,72,0.35)] focus-visible:outline focus-visible:outline-4 focus-visible:outline-brand-400" animate={reduceMotion ? undefined : {
        x: [0, -7, 7, -7, 7, -4, 4, 0]
      }} transition={reduceMotion ? undefined : {
        duration: 0.45,
        ease: 'easeInOut',
        repeat: Infinity,
        repeatDelay: 1.4
      }} data-id="element-129" data-mp="2pc5wxzxzdubz">
            Get Instant Access — $27
            <ArrowRightIcon className="h-5 w-5 shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-130" data-mp="4n8c4tb87y7g" />
          </motion.a>
        </motion.div>}
    </AnimatePresence>;
}